module.exports = __webpack_public_path__ + "static/01-designing@2x-ee1cb59c64e0a1c8109fec99cf690b7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/01-designing@2x.jpg
// module id = 2638
// module chunks = 35783957827783